<main class="container">
    <img src="assets/common/less.svg" style="visibility: hidden;">
    
    <h2 class="title text-center">
        Carga horária mínima presencial para cursos técnicos
    </h2>

    <div class="content">
        <div class="text-container text-justify">
            <p class="paragraph">
                Os cursos técnicos que compõem o <a href="http://cnct.mec.gov.br/" target="_blank" class="link custom-link">Catálogo Nacional de Cursos Técnicos (CNCT)</a> passarão a contar com uma carga
                horária presencial mínima voltada às atividades que exijam interação presencial e física entre grupos de estudantes, 
                sobretudo para o desenvolvimento de competências socioemocionais, as que possam apresentar risco à saúde ou ao patrimônio
                ao serem desenvolvidas sem supervisão ou para atividades que demandam práticas em oficinas, laboratórios ou ambientes de aprendizagem específicos.
                Esta carga horária mínima presencial aplica-se aos cursos presenciais, híbridos e na modalidade educação a distância. Não se incluem nas aulas presenciais
                aquelas desenvolvidas de modo síncrono, mediadas por tecnologias de comunicação. 
            </p>
            <p class="paragraph">
                Você pode opinar sobre o valor proposto para cada curso. Veja abaixo a proposta e, caso queira contribuir, preencha o formulário disponível ao final da página.
            </p>
            <p class="paragraph">
                <b>Atenção: </b>Esta consulta é somente para as cargas horárias mínimas presenciais dos cursos técnicos, caso queira contribuir para as
                cargas horárias dos cursos superiores de tecnologia, participe da avaliação do Catálogo Nacional de Cursos Superiores de Tecnologia <a class="link custom-link" routerLink="/aviso-sugestao">clicando aqui.</a>
            </p>
        </div>

        <div class="eixos content">
            <div class="eixo" *ngFor="let eixo of dadosConsulta[0]">
                <div class="title-container" appDisplay>
                    <button type="button" class="display-btn cursor-pointer">Expandir</button>
                    <h3 class="cursor-pointer">{{ eixo.nome }}</h3>
                </div>

                <div class="toggle">
                    <div class="area" *ngFor="let area of eixo.areas">
                        <div class="title-container areas" appDisplay>
                            <button type="button" class="display-btn display cursor-pointer">Expandir</button>
                            <h3 class="cursor-pointer">Área tecnológica: {{ area.nome }}</h3>
                        </div>

                        <div class="cursos toggle">
                            <div class="curso" *ngFor="let curso of area.cursos">
                                <div class="title-container" appDisplay>
                                    <button type="button" class="display-btn cursor-pointer">Expandir</button>
                                    <h3 class="cursor-pointer">{{ curso.nome }}</h3>
                                </div>

                                <div class="carga-horaria toggle"
                                [innerHTML]="curso.cargaHoraria | format"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <button class="btn rounded-pill btn-lg btn-green" routerLink="/envie-sugestao-cnct">Envie sua sugestão</button>

    <div class="forms-buttons">
        <div class="redirect-form">
            <h2 class="subtitle">Envie sugestões para o Catálogo Nacional de Cursos Superiores de Tecnologia</h2>
            <button class="btn rounded-pill btn-md btn-green" routerLink="/aviso-sugestao">Clique aqui</button>
        </div>
        <div class="redirect-form">
            <h2 class="subtitle">Envie sugestões para as áreas tecnológicas propostas</h2>
            <button class="btn rounded-pill btn-md btn-green" routerLink="/aviso-sugestao-areas">Clique aqui</button>
        </div>
    </div>
</main>